import React, { FC } from 'react';
import Barcode from 'react-barcode';

export interface PackingSlipPeelTabProps {
    orderNumber?: string;
}

//Show last 30 Characaters of the orderNumber
const last30Characters = (orderNumber: string) => orderNumber?.slice(-30);

const PackingSlipPeelTab: FC<PackingSlipPeelTabProps> = ({ orderNumber }) => (
    orderNumber ? (
        <tfoot
            className="print-footer"
        >
            <tr>
                <td>
                    <div className="print-footer-barcode-container">
                        <Barcode
                            value={last30Characters(orderNumber)}
                            height={36}
                            width={1}
                            format="CODE128"
                            fontSize={12}
                            displayValue={true}
                            margin={0}
                        />
                    </div>
                </td>
            </tr>

        </tfoot>
    ) : null
);

export default PackingSlipPeelTab;
